// hooks/useAtualizarDados.ts
import { useState } from "react";
// --------------------- Import Services ---------------------
import { atualizarRepresentante } from "../../../services/atualizarRepresentanteService";

export const useValidarRepresentante = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);

  const validarRepre = async (representanteId: number | undefined | null) => {
    setIsLoading(true);

    if (representanteId) {
      const now = new Date();
      const dataAssinatura = new Date(now);
      const dataVencimento = new Date(now);
      dataVencimento.setFullYear(dataVencimento.getFullYear() + 3);

      const representanteDataNovo = {
        checked: 1,
        active: 1,
        dataAssinatura: dataAssinatura,
        dataVencimento: dataVencimento,
        representanteId: representanteId,
      };

      try {
        const atualizarDados = await atualizarRepresentante(
          representanteDataNovo
        );

        if (atualizarDados) {
          setSuccess("Representante validado com sucesso!");
        } else {
          setError(
            "Não foi possível validar este representante. Tente Novamente!"
          );
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return { validarRepre, isLoading, error, success, resetError, resetSuccess };
};
